<template>
  <div class="terms-footer d-flex" >
    <div class="item">
      <img :src="docIcon">
      <a :href="getTermsLink" target="_blank">{{ $t('links.termsOfUser') }}</a>
    </div>
    <div class="item">
      <img :src="docIcon">
      <a style="" :href="getPrivacyPolicyLink" target="_blank">  {{ $t('links.privacyPolicy') }}</a>
    </div>
    <div class="item">
      <img :src="mapPointIcon">
      {{ $t('links.address') }}
    </div>
  </div>
</template>

<script>
import docIcon from '../assets/doc.svg'
import mapPointIcon from '../assets/map-point.svg'
export default {
  name: "FooterTerms",
  data() {
    return {
      docIcon, mapPointIcon
    }
  },
  computed: {
    getTermsLink() {
      const terms = {
        ru: 'https://dolphin-anty.net/legal/terms-of-use-ru.php',
        en: 'https://dolphin-anty.net/legal/terms-of-use.php',
        cn: 'https://dolphin-anty.net/legal/terms-of-use.php',
        ua: 'https://dolphin-anty.net/legal/terms-of-use.php',
        es: 'https://dolphin-anty.net/legal/terms-of-use.php'
      }
      return  terms[this.$i18n.locale]

    },
    getPrivacyPolicyLink() {
      const terms = {
        ru: 'https://dolphin-anty.net/legal/privacy-policy-ru.php',
        en: 'https://dolphin-anty.net/legal/privacy-policy.php',
        cn: 'https://dolphin-anty.net/legal/privacy-policy.php',
        ua: 'https://dolphin-anty.net/legal/privacy-policy.php',
        es: 'https://dolphin-anty.net/legal/privacy-policy.php'
      }
      return  terms[this.$i18n.locale]

    },

  }
}
</script>

<style  lang="scss">
.terms-footer {
  margin-top: 60px;
  font-size: 12px;

  .item {
    padding-right: 20px;
    display: flex;
    align-items: flex-end;

    img {
      margin-right: 10px;
      margin-bottom: 3px;
      height: 16px;
    }
  }

  a {
      font-size: 12px;
      line-height: 19px;
      color: #7E7E7E !important;
      text-decoration: none;
  }
}
</style>
